export default __webpack_public_path__ + "static/media/44.c6aa1cbe.jpg";